import { CSSProperties, forwardRef, ReactNode } from "react";
import styles from "./SheetTop.module.css";

type SheetTopProps = {
  children: ReactNode;
  className?: string | undefined;
  style?: CSSProperties;
  testId?: string | undefined;
};

const SheetTop = forwardRef<HTMLDivElement, SheetTopProps>(
  ({ children, className, style, testId }, ref) => {
    const combinedClassName = className
      ? `${styles["root"]} ${className}`
      : styles["root"];

    return (
      <div
        ref={ref}
        data-testid={testId}
        className={combinedClassName}
        style={style}
      >
        {children}
      </div>
    );
  }
);

SheetTop.displayName = "SheetTop";

export default SheetTop;
